<template>
  <div class="login-page d-flex flex-column flex-lg-row flex-column-fluid">
    <!--begin::Aside-->
    <div class="login-aside d-flex flex-column flex-lg-row-auto w-xl-600px position-xl-relative">
      <div class="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
        <div class="d-flex flex-column flex-center flex-grow-1 p-10 pt-lg-20">
          <h1 class="fw-bolder fs-2qx pb-5 pb-md-8 login-title">{{ $t('reset_aside_title') }}</h1>
          <p class="fw-bold fs-2 login-subtitle">
            {{ $t('reset_aside_text_start') }}
            <br /> {{ $t('reset_aside_text_end') }}
          </p>
          <div class="d-flex justify-content-center align-items-center mt-10">
            <img alt="Logo" src="/assets/media/r2b_login.jpg" class="login-hero-img" />
          </div>
        </div>
        <div class="login-aside-logo">
          <img alt="Qomerxia" src="/assets/media/logos/qomerxia-logo.png" class="h-20px" />
        </div>
      </div>
    </div>
    <!--end::Aside-->

    <!--begin::Body-->
    <div class="d-flex flex-column flex-lg-row-fluid">
      <!--begin::Language selector-->
      <div class="d-flex justify-content-end p-5">
        <div class="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px"
             data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
          <img class="h-20px w-20px rounded-sm" :src="currentLanguage.img" alt="" />
        </div>
        <div class="menu menu-sub menu-sub-dropdown menu-column w-150px" data-kt-menu="true">
          <div v-for="lang in langs" :key="lang.code" class="menu-item px-3">
            <a @click.prevent="changeLang(lang)" href="#" class="menu-link d-flex px-5 active">
              <span class="symbol symbol-20px me-4">
                <img class="rounded-1" :src="lang.img" :alt="$t(lang.title)" />
              </span>{{ $t(lang.title) }}
            </a>
          </div>
        </div>
      </div>
      <!--end::Language selector-->

      <!--begin::Form section-->
      <div class="d-flex flex-center flex-column flex-grow-1">
        <div class="login-form-card w-lg-500px p-10 p-lg-15 mx-auto">
          <form class="form w-100" id="kt_new_password_form">
            <!--begin::Heading-->
            <div class="text-center mb-11">
              <img alt="Qomerxia" src="/assets/media/logos/qomerxia-logo.png" class="h-45px mb-8 d-lg-none" />
              <h1 class="text-dark fw-bolder fs-2 mb-1">{{ $t('auth.new_password') }}</h1>
              <div class="login-separator my-6"></div>
            </div>
            <!--end::Heading-->

            <!--begin::Password-->
            <div class="mb-8 fv-row" data-kt-password-meter="true">
              <div class="mb-1">
                <label class="form-label fw-bolder text-dark fs-6 mb-2">{{ $t('auth.password') }}</label>
                <div class="position-relative mb-3">
                  <span class="login-input-icon">
                    <i class="bi bi-lock fs-4"></i>
                  </span>
                  <input v-model="form.password" class="form-control form-control-lg form-control-solid login-input login-input-password"
                         type="password" name="password" autocomplete="off" :placeholder="$t('auth.password')" />
                  <span class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2" data-kt-password-meter-control="visibility">
                    <i class="bi bi-eye-slash fs-2"></i>
                    <i class="bi bi-eye fs-2 d-none"></i>
                  </span>
                </div>
                <!--begin::Meter-->
                <div class="d-flex align-items-center mb-3" data-kt-password-meter-control="highlight">
                  <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
                  <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
                  <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
                  <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px"></div>
                </div>
                <!--end::Meter-->
              </div>
              <div class="text-muted fs-7">{{ $t('auth.password_conditions') }}.</div>
            </div>
            <!--end::Password-->

            <!--begin::Confirm password-->
            <div class="fv-row mb-8">
              <label class="form-label fw-bolder text-dark fs-6 mb-2">{{ $t('auth.cf_password') }}</label>
              <div class="position-relative">
                <span class="login-input-icon">
                  <i class="bi bi-lock-fill fs-4"></i>
                </span>
                <input v-model="form.password_confirmation" class="form-control form-control-lg form-control-solid login-input login-input-password"
                       :type="showConfirmPassword ? 'text' : 'password'" name="confirm-password" autocomplete="off"
                       :placeholder="$t('auth.cf_password')" />
                <span class="login-eye-icon" @click="showConfirmPassword = !showConfirmPassword">
                  <i :class="showConfirmPassword ? 'bi bi-eye' : 'bi bi-eye-slash'" class="fs-4"></i>
                </span>
              </div>
            </div>
            <!--end::Confirm password-->

            <!--begin::Action-->
            <div class="d-grid mt-10">
              <button type="submit" id="kt_new_password_submit" class="btn btn-lg btn-primary login-btn">
                <span class="indicator-label fw-bold">{{ $t('send') }}</span>
                <span class="indicator-progress">{{ $t('loading') }}
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              </button>
            </div>
            <!--end::Action-->
          </form>
        </div>
      </div>
      <!--end::Form section-->

      <!--begin::Footer-->
      <div class="d-flex flex-center py-5">
        <span class="text-muted fs-7">&copy; {{ new Date().getFullYear() }}</span>
      </div>
      <!--end::Footer-->
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'CreatePasswordView',
  data(){
    return {
      form : {
        password : '',
        password_confirmation : '',
        token: this.$route.params.token,
        id: this.$route.params.id,
      },
      user: {},
      showConfirmPassword: false,
      langs: {
        en : {
          'img': '/assets/media/united-states.svg',
          'title': 'header.language.english',
          'code': 'en'
        },
        fr : {
          'img': '/assets/media/france.svg',
          'title': 'header.language.french',
          'code': 'fr'
        },
      }
    }
  },
  computed : {
    currentLanguage(){
      return this.langs[this.$i18n?.locale]
    },
  },
  async mounted(){
    this.passwordChange()
    let response = await this.getUserByToken(this.$route.params.token)
    this.user = response.data.user
  },

  methods: {
    ...mapActions('auth', [
      'resetPassword',
      'getUserByToken'
    ]),
    changeLang(lang){
      this.$i18n.locale = lang.code
      localStorage.setItem('locale', lang.code)
    },
    passwordChange() {
      var e, t, r, o, s = () => {};

      e = document.querySelector("#kt_new_password_form"), t = document.querySelector("#kt_new_password_submit"), o = KTPasswordMeter.getInstance(e.querySelector('[data-kt-password-meter="true"]')), r = FormValidation.formValidation(e, {
        fields: {
          password: {
            validators: {
              notEmpty: {
                message: "The password is required"
              },
              callback: {
                message: "Please enter valid password",
                callback: function(e) {
                  if (e.value.length > 0) return s()
                }
              }
            }
          },
          "confirm-password": {
            validators: {
              notEmpty: {
                message: "The password confirmation is required"
              },
              identical: {
                compare: function() {
                  return e.querySelector('[name="password"]').value
                },
                message: "The password and its confirm are not the same"
              }
            }
          },
          toc: {
            validators: {
              notEmpty: {
                message: "You must accept the terms and conditions"
              }
            }
          }
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger({
            event: {
              password: !1
            }
          }),
          bootstrap: new FormValidation.plugins.Bootstrap5({
            rowSelector: ".fv-row",
            eleInvalidClass: "",
            eleValidClass: ""
          })
        }
      }), t.addEventListener("click", ((s) => {
        this.$loading('kt_new_password_submit')
        s.preventDefault(),
            r.revalidateField("password"),
            r.validate().then(( async (r) => {
              if ("Valid" == r){
                let data = {
                  email :  this.user ? this.user.email : '',
                  token : this.form.token,
                  password : this.form.password,
                  password_confirmation : this.form.password_confirmation
                }
                await this.resetPassword(data).then((res) => {
                  this.$stopLoading('kt_new_password_submit')
                  window.toastr.success(res.data.message)
                  this.$router.push('/login')
                }).catch(() => {
                  this.$stopLoading('kt_new_password_submit')
                })
              }else {
                this.$stopLoading('kt_new_password_submit')
                Swal.fire({
                  text: "Sorry, looks like there are some errors detected, please try again.",
                  icon: "error",
                  buttonsStyling: !1,
                  confirmButtonText: "Ok, got it!",
                  customClass: {
                    confirmButton: "btn btn-primary"
                  }
                })
              }
            }))
      })), e.querySelector('input[name="password"]').addEventListener("input", (function() {
        this.value.length > 0 && r.updateFieldStatus("password", "NotValidated")
      }))
    }
  },

  updated() {
    this.$nextTick(() => {
      KTApp.init();
    })
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
}

/* Aside panel */
.login-aside {
  background: linear-gradient(135deg, rgba(var(--platform-primary-rgb, 11, 61, 135), 0.06) 0%, #fff 50%, rgba(var(--platform-primary-rgb, 11, 61, 135), 0.1) 100%);
  height: 100vh;
  box-shadow: 4px 0 24px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.15);
}

.login-title {
  color: #1a1a2e;
}

.login-subtitle {
  color: #4a4a68;
  line-height: 1.6;
}

.login-hero-img {
  max-height: 360px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.2);
  object-fit: cover;
}

.login-aside-logo {
  position: absolute;
  bottom: 24px;
  right: 24px;
  opacity: 0.7;
}

/* Form card */
.login-form-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.login-separator {
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--platform-primary, #0b3d87), transparent);
  border-radius: 1px;
}

/* Input with icon */
.login-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #b5b5c3;
  z-index: 3;
  pointer-events: none;
}

.login-input {
  padding-left: 42px !important;
  border-radius: 10px !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-input:focus {
  border-color: var(--platform-primary, #0b3d87) !important;
  box-shadow: 0 0 0 3px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.15) !important;
}

.login-input-password {
  padding-right: 42px !important;
}

/* Eye toggle icon */
.login-eye-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #b5b5c3;
  cursor: pointer;
  z-index: 3;
  transition: color 0.2s ease;
}

.login-eye-icon:hover {
  color: var(--platform-primary, #0b3d87);
}

/* Submit button */
.login-btn {
  border-radius: 10px !important;
  padding: 12px 0 !important;
  font-size: 1.1rem !important;
  letter-spacing: 0.3px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(var(--platform-primary-rgb, 11, 61, 135), 0.35);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
}

/* Responsive */
/* Mobile et tablette : formulaire seul, sur la hauteur visible de l'écran (100dvh exclut la
   barre d'adresse, contrairement à 100vh) — le panneau d'accueil et son image sont masqués */
@media (max-width: 991.98px) {
  .login-page {
    min-height: 100dvh;
  }

  .login-aside {
    display: none !important;
  }

  .login-form-card {
    box-shadow: none;
    padding: 1.5rem !important;
  }

  .login-form-card .mb-11 {
    margin-bottom: 1.5rem !important;
  }

  .login-form-card .mb-8 {
    margin-bottom: 1.25rem !important;
  }

  .login-form-card .mt-10 {
    margin-top: 1.75rem !important;
  }
}
</style>
